<template>
  <div class="cbaas-btn-style">
    <template v-for="(item, index) in btnList">
      <div v-if="item.isFill" :key="index" class="fill"></div>
      <template v-else>
        <el-button
          v-show="item.auth ? $utils.hasAuth($store, item.auth) : true"
          :key="index"
          :type="item.type || 'primary'"
          :disabled="item.isDisable ? item.isDisable(): false"
          @click="item.click()"
        >
          <div class="btn-content">
            <span v-if="item.icon" :class="['iconfont', item.icon, 'btn-icon']"></span>
            <span class="btn-text">
              {{ item.btnContent }}
            </span>
          </div>
        </el-button>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: {
    btnList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.cbaas-btn-style {
  @include adaptation(
    (
      --cbaas-btn-style-item-margin-left: 16px,
      --cbaas-btn-style-item-content-lineheight: 16px,
      --cbaas-btn-style-item-icon-margin-right: 4px,
      --cbaas-btn-style-item-icon-fontsize: 16px,
      --cbaas-btn-style-item-text-fontsize: 12px
    )
  );
  display: flex;
  align-items: center;

  .el-button {
    &:not(:first-child) {
      margin-left: var(--cbaas-btn-style-item-margin-left);
    }

    /deep/ .btn-content {
      display: flex;
      height: var(--cbaas-btn-style-item-content-lineheight);
      line-height: var(--cbaas-btn-style-item-content-lineheight);

      .btn-icon {
        margin-right: var(--cbaas-btn-style-item-icon-margin-right);
        font-size: var(--cbaas-btn-style-item-icon-fontsize);
      }

      .btn-text {
        font-size: var(--cbaas-btn-style-item-text-fontsize);
      }
    }
  }

  .fill {
    flex-grow: 1;
  }
}
</style>
